import { h, Component } from 'preact';
import { connect } from 'preact-redux';
import classNames from 'classnames';
import { myStuffLayoutSelector } from 'app/desktop/selectors/myStuffLayout';
import NoReRender from 'app/common/components/NoReRender';

class MyStuffLayout extends Component {
  render() {
    const { tabs } = this.props;
    return (
      <div id="ls-my-stuff-tabs" className="tabs-container ls-my-stuff">
        <ul className="tabs" data-bhw="UserProfileNavBar">
          {tabs.map(tab => (
            <li
              id={tab.id}
              className={classNames({
                active: tab.active,
              })}
              data-bhc={tab.bhc}
              data-bhw={tab.bhw}
              key={tab.id}
            >
              <NoReRender tagName="a" href={tab.url} key={`link-${tab.id}`}>
                {tab.text}
              </NoReRender>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default connect(myStuffLayoutSelector)(MyStuffLayout);
